export const getSmartSuiteLink = (smartsuiteBackendUrl: string): string => {
  return smartsuiteBackendUrl
    .replace("smartsuite", "ss-stage")
    .replace("/api/v1", "");
};

export const getLinkToTable = (
  smartsuiteLink: string,
  accountId: string,
  solutionId: string,
): string => {
  return `${smartsuiteLink}/${accountId}/solution/${solutionId}`;
};
